<template>
  <div class="__dropdown" ref="dropdown" v-click-outside="clickOutsideEvent">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style="cursor: pointer;"
      @click="isDropdown = true"
    >
      <path
        d="M13.6842 11.9996C13.6842 12.9312 12.9316 13.6839 12 13.6839C11.0684 13.6839 10.3158 12.9312 10.3158 11.9996C10.3158 11.0681 11.0684 10.3154 12 10.3154C12.9316 10.3154 13.6842 11.0681 13.6842 11.9996ZM18.3158 10.3154C17.3842 10.3154 16.6316 11.0681 16.6316 11.9996C16.6316 12.9312 17.3842 13.6839 18.3158 13.6839C19.2474 13.6839 20 12.9312 20 11.9996C20 11.0681 19.2474 10.3154 18.3158 10.3154ZM5.68421 10.3154C4.75263 10.3154 4 11.0681 4 11.9996C4 12.9312 4.75263 13.6839 5.68421 13.6839C6.61579 13.6839 7.36842 12.9312 7.36842 11.9996C7.36842 11.0681 6.61579 10.3154 5.68421 10.3154Z"
        fill="#74788D"
      />
    </svg>
    <div class="__dropdown_overlay" v-if="isDropdown" @click.stop="isDropdown = false"></div>
    <div class="__dropdown_content" v-if="isDropdown">
      <a
        class="__dropdown_item"
        v-for="(option, index) in options"
        :key="index"
        :class="option.color"
        @click="!option.disabled ? chooseOption(option.text) : false"
      >
        <span>
          {{ option.text }}
        </span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isDropdown: false
    }
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    clickOutsideEvent() {
      this.isDropdown = false
    },

    chooseOption(value) {
      this.$emit('select', value)
      this.isDropdown = false
    }
  }
};
</script>

<style lang="scss" scoped>
.__dropdown_overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
}
.danger {
  color: #dc2323 !important;
}

.secondary {
  color: #2348bf !important;
  font-weight: 700 !important;
}

.__dropdown_btn {
  background: #ffffff;
  border: 1px solid #c7c9d1;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
  color: #23313e;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  padding: 8px 14px;
  height: 44px;
}

.__dropdown {
  position: relative;
  display: inline-block;
  width: 100%;
}

.__dropdown_content {
  position: absolute;
  transform: translate(0, 8px);
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  overflow: hidden;
  min-width: 300px;
  z-index: 99;
  cursor: pointer;
  // 
  right: 0;

  .__dropdown_item {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    width: 100%;
    height: 44px;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
  }
  > .__dropdown_item:not(:first-child) {
    border-top: 1px solid #ddd;
  }
}

.__dropdown_content a:hover {
  background-color: #f1f1f1;
}

.__dropdown:hover .__dropdown_btn {
  background-color: #ffffff;
}
</style>